import { useEffect } from "react";

/**
 * Passes the toggles of the chart type menu to the chart engine:
 *   - timerEnabled      → bar timer right of the last bar (off on Line, see effectiveChartSettings)
 *   - autoscrollEnabled → new bars scroll the view (D18)
 *   - gridSnapEnabled   → points of drawings stick to O/H/L/C of the bar (E14)
 *
 * @param {object|null} engine            - ChartEngine, null until created
 * @param {object}      effectiveSettings - settings the chart runs with
 */
const useChartToggles = (engine, { timerEnabled, autoscrollEnabled, gridSnapEnabled }) => {
  useEffect(() => {
    engine?.setToggles({ timerEnabled, autoscrollEnabled, gridSnapEnabled });
  }, [engine, timerEnabled, autoscrollEnabled, gridSnapEnabled]);
};

export default useChartToggles;
